import { Flex, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SideActionsWrapper = styled(Flex)`
  height: 100%;
  margin-right: ${Spacing.S12};
`
